import React, { useEffect, useState } from "react";
import ChatLayout from "../../components/chat/ChatLayout";
import { useAuth } from "../../context/AuthContext";
import { chatAPI } from "../../utils/chatAPI";

function AdminChat() {
  const { user } = useAuth();
  const [organizationId, setOrganizationId] = useState(null);
  const [organizations, setOrganizations] = useState([]);
  const [loading, setLoading] = useState(true);

  const [isOnline, setIsOnline] = useState(false);

  
  useEffect(() => {
    const loadOrganizations = async () => {
      if (!user) return;
      try {
        const data = await chatAPI.getAccessibleOrganizations();
        const list = Array.isArray(data) ? data : data?.data || data?.results || [];
        setOrganizations(list);
        setOrganizationId(list?.[0]?.id || null);
      } catch (err) {
        setOrganizations([]);
      } finally {
        setLoading(false);
      }
    };

    loadOrganizations();
  }, [user]);

  if (loading) {
    return (
      <div className="page-content">
        <div className="card">Loading chat...</div>
      </div>
    );
  }

  if (!organizationId) {
    return (
      <div className="page-content">
        <div className="card">No organization available for chat.</div>
      </div>
    );
  }

  return (
    <div className="page-content">
      <div className="card" style={{ marginBottom: "16px" }}>
        <label>Organization</label>
        <select
          value={organizationId}
          onChange={(e) => setOrganizationId(Number(e.target.value))}
          style={{ padding: "8px 12px", minWidth: "200px", borderRadius: "6px" }}
        >
          {organizations.map((org) => (
            <option key={org.id} value={org.id}>
              {org.name}
            </option>
          ))}
        </select>
      </div>
      <ChatLayout organizationId={organizationId} />
    </div>
  );
}

export default AdminChat;
